import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { auth } from "firebase/app";
import { Storage } from "@ionic/storage";
import { UsersFirebaseService } from "@mobile/app/services/firebase/users-firebase.service";
import { User } from "@mobile/app/shared/types/user.types";

@Injectable()
export class AuthProvider {
  constructor(
    private storage: Storage,
    public afAuth: AngularFireAuth,
    private usersService: UsersFirebaseService
  ) {}

  // Create user
  register = (data: { email: string; password: string }) =>
    this.afAuth.createUserWithEmailAndPassword(data.email, data.password);

  // Login user
  login = async (data: { email: string; password: string }) => {
    await this.afAuth.setPersistence(auth.Auth.Persistence.LOCAL);
    return this.afAuth.signInWithEmailAndPassword(data.email, data.password);
  };

  resetPassword(email) {
    return this.afAuth.sendPasswordResetEmail(email);
  }

  async updateEmail(newEmail) {
    let user = await this.storage.get("user");
    const currentUserFirestore = await this.usersService.getUser(user["uid"]);
    currentUserFirestore.email = newEmail;

    const currentUser = await this.afAuth.currentUser;
    // A atualização do documento do usuário será feita no método updateCurrentUser
    currentUser.updateEmail(newEmail);

    return this.afAuth.updateCurrentUser(currentUser);
  }

  async updateCurrentUser({ user, resetPassword }) {
    const currentUser = await this.afAuth.currentUser;
    if (resetPassword) {
      currentUser.updatePassword(resetPassword.newpassword);
    }
    currentUser.updateEmail(user.email);
    // currentUser.updatePhoneNumber(`+55${user.tel}`);
    currentUser.updateProfile({
      displayName: user.name,
    });

    await this.afAuth.updateCurrentUser(currentUser);

    let userStorage = await this.storage.get("user");
    const uid = userStorage["uid"] || currentUser.uid;
    const userData: Partial<User> = {
      name: user.name,
      tel: user.tel,
      email: user.email,
    };
    await this.usersService.updateUser(uid, userData);
  }
}
